<template>
  <div class="bg-darkgrey text-center py-2">
    <span>{{$t('KNEVersion.version')}} {{version}}</span>
  </div>
</template>

<script>
export default {
  name: 'KNEVersion',

  data () {
    return {
      version: '4.1.13'
    }
  }
}
</script>

<style>

</style>
